import React, { useState, useEffect } from "react";
import { Box, Paper, Grid, styled, TextField, Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Slider from "@mui/material/Slider";
import { visuallyHidden } from "@mui/utils";
import CircularProgress from "@mui/material/CircularProgress";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate, useLocation } from "react-router-dom";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DashboardNavbar from "../../components/DashboardNavbar";
import { H4, H5, Small } from "../../components/Typography";
import { load, remove } from "../../constants/storage";
import * as Models from "../../models";
import {
  getFundSipList,
  getNFOFundList,
  getFundisin,
} from "redux/actions/PortfolioAction";
import InsertDots from "../../constants/InsertDots";
import {
  amcItems,
  catItems,
  riskFilterItems,
  subCategoryFilterItems,
} from "../../constants/constant";
import { toast } from "react-hot-toast";
import { API_BASE_URL } from "../../Api/EndPoints";
import { getAMCList } from "../../redux/actions/KYCAction";
import FilterScreenMobile from "../../components/FilterScreenMobile";

const marks = [
  {
    value: 100,
    label: "100",
  },
  {
    value: 500,
    label: "500",
  },
  {
    value: 1000,
    label: "1000",
  },
];

const MFCollections = () => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  let routeData = useLocation();
  const { customer, item, goalData } = routeData.state;
  const [amcData, setAMCData] = React.useState<any>(amcItems);
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>(
    item?.title == "NFO" ? "opendate" : "returns"
  );
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const [page, setPage] = React.useState(0);
  const [selectedRisk, setSelectedRisk] = React.useState<string>("ALL");
  const [selectedCategory, setSelectedCategory] = React.useState<string>("");
  const [selectedAMC, setSelectedAMC] = React.useState<string>("");
  const [selectedAMCCode, setSelectedAMCCode] = React.useState<string>("");
  const [selectedSubCategory, setSelectedSubCategory] =
    React.useState<string>("");
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(true);
  const [data, setData] = React.useState([]);
  const [sliderValue, setSlidervalue] = React.useState<any>("");
  const [allAmcData, setAllAmcData] = useState(amcItems);
  const [mfData, setMfData] = useState();
  const [filterModel, setFilterModel] = useState(false);
  const [closeDate, setCloseDate] = useState();

  function valuetext(value: number) {
    setSlidervalue(value);
    return `${value}`;
  }
  const valueLabelFormat = (value: number) => {
    const mark = marks.find((mark) => mark.value === value);
    return mark ? mark.label : "";
  };

  const threeYearsReturn = (row: any) => {
    return row?.performance?.["3Y"] ?? "NA";
  };
  useEffect(() => {
    checkToken();
  }, [item]);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getAMCListData();
      if (item?.title == "NFO") {
        getNFOFundSipListData();
        return;
      }
      if (item?.type?.trim() || item?.asset_sub_category?.trim()) {
        if (!item?.isRefresh) {
          filterRequest();
        }
      }
    }
  };

  var dateInTodayORFuture = function (firstDate: Date, secondDate: Date) {
    if (firstDate.setHours(0, 0, 0, 0) == secondDate.setHours(0, 0, 0, 0)) {
      return true;
    }
    if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
      return false;
    }
    return true;
  };

  const getNFOFundSipListData = async () => {
    setLoading(true);
    let token = await load("token");
    dispatch(getNFOFundList(`${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode == 200) {
          setData(response?.data);
          return;
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const getAMCListData = () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const data = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails.refcode,
      source: "web",
    };
    let token = load("token");
    dispatch(getAMCList(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        setAMCData(response?.amcData);
        setAllAmcData(response?.amcData);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const filterRequest = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.FundSipRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
      amc_code: "",
      asset_category: item?.asset_sub_category === "Index" ? "Equity" : "",
      asset_sub_category:
        item?.asset_sub_category === "Equity"
          ? ""
          : item?.asset_sub_category ?? "",
      fund_type:
        item?.asset_sub_category === "Equity"
          ? "Equity"
          : item?.type === "elss"
          ? "elss"
          : item?.type === "Fixed Income"
          ? "Fixed Income"
          : item?.type === "Global"
          ? item?.type
          : item?.type === "Hybrid"
          ? "Hybrid"
          : item?.type === "Equity"
          ? "Equity"
          : "ALL",

      min_initial_investment: item?.minAmount ?? "",
      offset: 0,
      risk_profile: "ALL",
    };
    await getFundSipListData(req);
  };

  const getFundSipListData = async (req: any) => {
    setLoading(true);
    let token = load("token");

    dispatch(getFundSipList(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          return;
        }
        const sortedData = response?.flexiData?.sort((a: any, b: any) =>
          (a?.vr_rating === "Not Rated" ? -1 : a?.vr_rating?.length) <
          (b?.vr_rating === "Not Rated" ? -1 : b?.vr_rating?.length)
            ? 1
            : -1
        );

        if (item?.isGoal) {
          let goalSortedList = sortedData?.filter(
            (a: any) => Number(item?.sipAmount) >= Number(a?.min_sip_amount)
          );
          let goalList = goalSortedList.map(function (ele: any) {
            return { ...ele, isGoal: item?.isGoal };
          });
          setData(goalList);
          return;
        }
        setData(sortedData);
        const mfdata: any = data?.map((item: any) => {
          return item;
        });
        setMfData(mfdata);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const handleFilterProceedHandle = async (value: any) => {
    setData(value);
    setFilterModel(false);
  };

  const handleFilterCloseHandle = async () => {
    setFilterModel(false);
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  interface Data {
    name?: string;
    returns?: number;
    nav?: number;
    rating?: number;
    mininvestment?: number;
    fundsize?: number;
    risk?: string;
    opendate?: number;
    closedate?: number;
  }

  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  type Order = "asc" | "desc";

  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort<T>(
    array: readonly T[],
    comparator: (a: T, b: T) => number
  ) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  interface HeadCell {
    disablePadding: boolean;
    id: keyof Data;
    label: string;
    numeric: boolean;
  }

  const headCells: readonly HeadCell[] = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Mutual Fund Name",
    },
    {
      id: "returns",
      numeric: true,
      disablePadding: false,
      label: "3 Years Returns",
    },

    {
      id: "rating",
      numeric: true,
      disablePadding: false,
      label: "Rating",
    },
    {
      id: "fundsize",
      numeric: true,
      disablePadding: false,
      label: "Fund Size",
    },
    {
      id: "mininvestment",
      numeric: true,
      disablePadding: false,
      label: "Min. Investment",
    },
    {
      id: "risk",
      numeric: true,
      disablePadding: false,
      label: "Risk",
    },
  ];

  const NFOheadCells: readonly HeadCell[] = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Mutual Fund Name",
    },
    {
      id: "opendate",
      numeric: true,
      disablePadding: false,
      label: "Open Date",
    },
    {
      id: "closedate",
      numeric: true,
      disablePadding: false,
      label: "Close Date",
    },
    {
      id: "mininvestment",
      numeric: true,
      disablePadding: false,
      label: "Min. Investment",
    },
  ];

  interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (
      event: React.MouseEvent<unknown>,
      property: keyof Data
    ) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#FFF3DB",
      color: "#000",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  function EnhancedTableHead(props: EnhancedTableProps) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler =
      (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
      };

    return (
      <TableHead>
        {item?.title == "NFO" ? (
          <TableRow>
            {NFOheadCells.map((headCell, index) => (
              <StyledTableCell
                key={headCell.id}
                align={headCell.numeric ? "left" : "left"}
                padding={"normal"}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                  sx={{
                    ml: index === 0 ? 1.8 : 0,
                    mt: 0.7,
                  }}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </StyledTableCell>
            ))}
          </TableRow>
        ) : (
          <TableRow>
            {headCells.map((headCell, index) => (
              <StyledTableCell
                key={headCell.id}
                align={headCell.numeric ? "left" : "left"}
                padding={"normal"}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                  sx={{
                    ml: index === 0 ? 1.8 : 0,
                    mt: 0.7,
                  }}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </StyledTableCell>
            ))}
          </TableRow>
        )}
      </TableHead>
    );
  }

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = data.map((n: any) => n?.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const getFundSipDetail = async (data: any) => {
    setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualFundsDetailRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: data?.isin,
    };

    dispatch(getFundisin(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          return;
        }
        if (response?.error) {
          toast.error(
            "We are currently unable to process your request. Please try again later"
          );
          return;
        }
        navigate("/nfofunddetails", {
          state: {
            data: data,
            customer: customer,
          },
        });
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const handleClick = (event: React.MouseEvent<unknown>, data: any) => {
    if (item?.title == "NFO") {
      var now = new Date();
      var past = new Date(data?.closure_date);

      if (dateInTodayORFuture(past, now)) {
        getFundSipDetail(data);
        return;
      }
      toast.error(
        "The NFO has officially closed its investment period. Seek out live NFOs to stay updated on the latest investment possibilities."
      );
    } else {
      navigate("/funddetails", {
        state: {
          data: data,
          customer: customer,
          goalData: goalData,
        },
      });

      setSelected(selected);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name: string) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty data.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  const onhandleBlur = (event: any) => {
    const textData = event.target.value.toUpperCase();

    const newData = allAmcData?.filter(function (item: any) {
      const leavetypeData = item?.amc_name
        ? item?.amc_name?.toUpperCase()
        : "".toUpperCase();
      return leavetypeData.indexOf(textData) > -1;
    });
    setAMCData(newData);
  };

  const applyFilter = () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.FundSipRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
      amc_code: selectedAMCCode,
      asset_category: selectedCategory === "Index" ? "Equity" : "",
      asset_sub_category:
        selectedSubCategory === "ALL"
          ? ""
          : selectedSubCategory === "High Returns"
          ? "Small Cap"
          : selectedSubCategory === ""
          ? item?.asset_sub_category
          : selectedSubCategory,
      fund_type: "ALL",
      min_initial_investment: sliderValue === 0 ? "" : sliderValue,
      offset: 0,
      risk_profile: selectedRisk,
      title: selectedSubCategory === "" ? item.title : selectedSubCategory,
    };

    getFundSipListData(req);
  };

  const cancelFilter = () => {};
  const toggleSelectedAMC = (itemName: string, item: any) => {
    setSelectedAMC(itemName);
    setSelectedAMCCode(item.amc_code);
  };

  const pressClear = () => {
    setSelectedAMC("");
    setSelectedAMCCode("");
    setSelectedCategory("");
    setSelectedRisk("ALL");
    setSelectedSubCategory("");
    setSlidervalue("");
  };

  const getImgUrl = (pic: string) => {
    if (pic) {
      return API_BASE_URL + pic;
    }
    return "";
  };

  return (
    <>
      <DashboardNavbar />
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Grid
          container
          spacing={0}
          sx={{
            pl: {
              md: 6,
              xs: 2,
            },
            pr: {
              md: 6,
              xs: 2,
            },
            pt: 2,
          }}
        >
          {/* Filter Grid */}
          {item?.title == "Global" ||
          item?.title == "Sector Specific" ||
          item?.title == "Solution Oriented" ||
          item?.title == "NFO" ||
          item?.isGoal ||
          item?.title === "Thematic" ? null : (
            <Grid
              item
              xs={1.8}
              sx={{
                boxShadow: 2,
                display: {
                  xs: "none",
                  md: "flex",
                  sm: "flex",
                },
                flexDirection: {
                  xs: "none",
                  md: "column",
                  sm: "column",
                },
              }}
            >
              <Box
                sx={{
                  background: "#FFF3DB",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  display: "flex",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  borderBottom: "0.5px solid #D2D2D2",
                }}
              >
                <H4
                  fontSize={14}
                  fontWeight={"500"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    mb: 2,
                    mt: 2,
                    ml: 1,
                  }}
                >
                  Filters
                </H4>
                <Grid onClick={pressClear}>
                  <H4
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      mb: 2,
                      mt: 2,
                      mr: 1,
                      color: "#DD9401",
                      cursor: "pointer",
                      fontSize: {
                        xs: 10,
                        md: 12,
                      },
                    }}
                  >
                    Clear all
                  </H4>
                </Grid>
              </Box>
              <H5
                fontWeight={"500"}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  background: "#F6F6F6",
                  pt: 1,
                  pb: 1,
                  pl: 2,
                }}
              >
                AMC
              </H5>
              <Box
                sx={{
                  background: "#fff",
                  justifyContent: "center",
                  // alignItems:'center',
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                <TextField
                  id="standard-bare"
                  variant="outlined"
                  placeholder="Search"
                  onChange={onhandleBlur}
                  // value={searchText}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        style={{
                          marginRight: -15,
                        }}
                      >
                        <SearchRoundedIcon
                          style={{
                            fontSize: "16px",
                            color: "#D3D3D3",
                          }}
                        />
                      </IconButton>
                    ),
                    style: {
                      height: "30px",
                      marginTop: 5,
                      width: "90%",
                      marginLeft: 10,
                      marginRight: 10,
                      marginBottom: 10,
                    },
                  }}
                />

                <Box sx={scrollableContainerStyle}>
                  {amcData.map((item: any, index: any) => (
                    <Box
                      sx={{
                        pt: 1.2,
                        pb: 1.2,
                        pr: 2,
                        pl: 1,
                        alignItems: "center",
                        display: "flex",
                        borderBottom: "0.5px solid #D2D2D2",
                        cursor: "pointer",
                      }}
                      onClick={() => toggleSelectedAMC(item.amc_name, item)}
                    >
                      <DoneRoundedIcon
                        style={{
                          fontSize: "20px",
                          color:
                            selectedAMC === item.amc_name
                              ? "#DD9401"
                              : "#D3D3D3",
                        }}
                      />
                      <Small
                        sx={{
                          fontWeight: "500",
                          ml: 0.4,

                          width: "90%",

                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {item.amc_name}
                      </Small>
                    </Box>
                  ))}
                </Box>
              </Box>

              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                  marginTop: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Category
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    {catItems.map((item: any, index: any) => (
                      <Box
                        sx={{
                          pt: 1.2,
                          pb: 1.2,
                          pr: 2,
                          pl: 1,
                          alignItems: "center",
                          display: "flex",
                          borderBottom: "0.5px solid #D2D2D2",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedCategory(item.name)}
                      >
                        <DoneRoundedIcon
                          style={{
                            fontSize: "20px",
                            color:
                              selectedCategory === item.name
                                ? "#DD9401"
                                : "#D3D3D3",
                          }}
                        />
                        <Small
                          sx={{
                            fontWeight: "500",
                            ml: 0.4,

                            width: "90%",

                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item.name}
                        </Small>
                      </Box>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Risk
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    {riskFilterItems.map((item: any, index: any) => (
                      <Box
                        sx={{
                          pt: 1.2,
                          pb: 1.2,
                          pr: 2,
                          pl: 1,
                          alignItems: "center",
                          display: "flex",
                          borderBottom: "0.5px solid #D2D2D2",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedRisk(item.name)}
                      >
                        <DoneRoundedIcon
                          style={{
                            fontSize: "20px",
                            color:
                              selectedRisk === item.name
                                ? "#DD9401"
                                : "#D3D3D3",
                          }}
                        />
                        <Small
                          sx={{
                            fontWeight: "500",
                            ml: 0.4,

                            width: "90%",

                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item.name}
                        </Small>
                      </Box>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Investment
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <Box sx={{ pl: 2, pr: 2 }}>
                      <H5
                        fontWeight={"500"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          pt: 2,
                          pb: 2,
                        }}
                      >
                        {sliderValue}
                      </H5>
                      <Slider
                        aria-labelledby="discrete-slider-values"
                        valueLabelDisplay="auto"
                        getAriaValueText={valuetext}
                        step={null}
                        marks={marks}
                        min={0}
                        max={1000}
                        valueLabelFormat={valueLabelFormat}
                      />
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                sx={{
                  background: "#F6F6F6",
                  boxShadow: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <H5
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Sub Category
                  </H5>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    background: "#f00",
                    boxShadow: 0,
                    p: 0,
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      justifyContent: "center",
                      // alignItems:'center',
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    {subCategoryFilterItems.map((item: any, index: any) => (
                      <Box
                        sx={{
                          pt: 1.2,
                          pb: 1.2,
                          pr: 2,
                          pl: 1,
                          alignItems: "center",
                          display: "flex",
                          borderBottom: "0.5px solid #D2D2D2",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedSubCategory(item.title)}
                      >
                        <DoneRoundedIcon
                          style={{
                            fontSize: "20px",
                            color:
                              selectedSubCategory === item.title
                                ? "#DD9401"
                                : "#D3D3D3",
                          }}
                        />
                        <Small
                          sx={{
                            fontWeight: "500",
                            ml: 0.4,

                            width: "90%",

                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item.title}
                        </Small>
                      </Box>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Box
                sx={{
                  background: "#fff",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  display: "flex",
                  mt: 1,
                }}
              >
                <Button
                  onClick={applyFilter}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={[sxStylebutton, { textTransform: "none" }]}
                >
                  Apply
                </Button>
                <Button
                  variant="contained"
                  onClick={cancelFilter}
                  sx={[cancel, { textTransform: "none" }]}
                >
                  Cancel
                </Button>
              </Box>
            </Grid>
          )}
          {/* MutualFundList */}
          <Grid
            item
            xs={
              item?.title == "Global" ||
              item?.title == "Sector Specific" ||
              item?.title == "Solution Oriented" ||
              item?.title == "Thematic" ||
              item?.title == "NFO" ||
              item?.isGoal
                ? 12
                : 10
            }
            sx={{
              ml: 2,
              display: {
                xs: "none",
                md: "flex",
                sm: "flex",
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                  <Table
                    sx={{ minWidth: 780 }}
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={data.length}
                    />
                    {item?.title == "NFO" ? (
                      <TableBody>
                        {stableSort(data, getComparator(order, orderBy))
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: any, index: any) => {
                            const isItemSelected = isSelected(row?.scheme_name);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow
                                hover
                                onClick={(event: any) =>
                                  handleClick(event, row)
                                }
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.scheme_name}
                                selected={isItemSelected}
                                sx={{ cursor: "pointer" }}
                              >
                                <TableCell
                                  component="th"
                                  id={labelId}
                                  scope="row"
                                  padding="normal"
                                  sx={{
                                    // width: 350,
                                    display: "flex",
                                    mt: 0.5,
                                  }}
                                >
                                  <Box
                                    component="img"
                                    sx={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: 44,
                                      minwidth: {
                                        md: 20,
                                        xs: 30,
                                        sm: 30,
                                      },
                                      borderRadius: 1,
                                      ml: 1,
                                      mr: 1,
                                    }}
                                    src={
                                      getImgUrl(
                                        `funds/${row?.amc_code}` + ".png"
                                      )
                                        ? getImgUrl(
                                            `funds/${row?.amc_code}` + ".png"
                                          )
                                        : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                                    }
                                  />
                                  {InsertDots(row?.scheme_name, 100)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 140,
                                  }}
                                >
                                  {row?.launch_date}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 120,
                                  }}
                                >
                                  {row?.closure_date}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 120,
                                  }}
                                >
                                  <span style={{ fontFamily: "Arial" }}>₹</span>
                                  {row?.min_investment}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}
                          >
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                    ) : (
                      <TableBody>
                        {stableSort(data, getComparator(order, orderBy))
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: any, index: any) => {
                            const isItemSelected = isSelected(row?.scheme_name);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow
                                hover
                                onClick={(event: any) =>
                                  handleClick(event, row)
                                }
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.scheme_name}
                                selected={isItemSelected}
                                sx={{ cursor: "pointer" }}
                              >
                                <TableCell
                                  component="th"
                                  id={labelId}
                                  scope="row"
                                  padding="normal"
                                  sx={{
                                    // width: 350,
                                    display: "flex",
                                    mt: 0.5,
                                  }}
                                >
                                  <Box
                                    component="img"
                                    sx={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: 44,
                                      minwidth: {
                                        md: 20,
                                        xs: 30,
                                        sm: 30,
                                      },
                                      borderRadius: 1,
                                      ml: 1,
                                      mr: 1,
                                    }}
                                    src={API_BASE_URL + row?.logo}
                                    alt="mf-logo-image"
                                  />
                                  {InsertDots(row?.scheme_name, 60)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 140,
                                    // textAlign: "center",
                                  }}
                                >
                                  {threeYearsReturn(row) == "NA"
                                    ? threeYearsReturn(row)
                                    : `${threeYearsReturn(row)}%`}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 80,
                                  }}
                                >
                                  {row?.vr_rating == "Not Rated" ||
                                  row?.vr_rating?.length <= 0
                                    ? 0
                                    : row?.vr_rating?.length}
                                  <Box
                                    component="img"
                                    sx={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: 12,
                                      minwidth: {
                                        md: 20,
                                        xs: 70,
                                        sm: 60,
                                      },
                                      ml: 0.5,
                                    }}
                                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/startIcon.svg"
                                    alt="saas-dasboard-footer"
                                  />
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 120,
                                  }}
                                >
                                  <span style={{ fontFamily: "Arial" }}>₹</span>
                                  {row?.fund_size} Cr
                                </TableCell>
                                <TableCell
                                  sx={{
                                    width: 150,
                                    // textAlign: "center",
                                  }}
                                >
                                  <span style={{ fontFamily: "Arial" }}>₹</span>
                                  {row?.min_initial_investment}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    width: 10,
                                  }}
                                >
                                  {row?.risk_profile}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}
                          >
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Box>
          </Grid>
          <FilterScreenMobile
            open={filterModel}
            item={item}
            handleClose={handleFilterCloseHandle}
            handleSave={handleFilterProceedHandle}
            data={amcData}
            allData={allAmcData}
          />

          {/* For small devices */}
          <>
            {item?.title == "Global" ||
            item?.title == "Sector Specific" ||
            item?.title == "Solution Oriented" ||
            item?.title == "NFO" ||
            item?.isGoal ||
            item?.title === "Thematic" ? null : (
              <Grid
                justifyContent="space-between"
                sx={{
                  flex: 1,
                  flexDirection: "row",
                  display: { xs: "flex", md: "none", sm: "none" },
                  marginBottom: 1,
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => setFilterModel(true)}
                >
                  <H4 fontSize={14} fontWeight={500}>
                    Filter
                  </H4>
                  <Box
                    component="img"
                    sx={{
                      height: 12,
                      minwidth: 10,
                      ml: 0.5,
                    }}
                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/FilterIcon.svg"
                    alt="saas-dasboard-footer"
                  />
                </Grid>

                <H4 fontSize={14} fontWeight={500}>
                  Rating
                </H4>
              </Grid>
            )}

            {item?.title == "NFO"
              ? data?.map((item: any) => (
                  <Grid
                    onClick={(event: any) => handleClick(event, item)}
                    sx={root}
                  >
                    <Grid justifyContent="center" alignItems="center">
                      <Box
                        sx={{
                          display: "flex",
                          borderRadius: 1,
                        }}
                      >
                        <Box
                          component="img"
                          src={
                            getImgUrl(`funds/${item?.amc_code}` + ".png")
                              ? getImgUrl(`funds/${item?.amc_code}` + ".png")
                              : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                          }
                          sx={{ height: 35, minwidth: 35, m: 0.6, mb: 0 }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            marginLeft: 1.5,
                          }}
                        >
                          <H4
                            fontSize={12}
                            fontWeight={500}
                            color="#000000"
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              display: "flex",
                              fontSize: 15,
                              mt: 0.13,
                            }}
                          >
                            {InsertDots(item?.scheme_name, 50)}
                          </H4>

                          <Grid
                            alignItems="center"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <H5
                              fontSize={12}
                              color="#747474"
                              fontWeight={"400"}
                            >
                              Open Date: {item?.launch_date}
                            </H5>
                            <H5
                              fontSize={12}
                              color="#747474"
                              fontWeight={"400"}
                            >
                              Close Date: {item?.closure_date}
                            </H5>
                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                ))
              : data?.map((item: any) => (
                  <Grid
                    onClick={(event: any) => handleClick(event, item)}
                    sx={root}
                  >
                    <Grid justifyContent="center" alignItems="center">
                      <Box
                        sx={{
                          display: "flex",
                          borderRadius: 1,
                        }}
                      >
                        <Box
                          component="img"
                          src={
                            getImgUrl(`funds/${item?.amc_code}` + ".png")
                              ? getImgUrl(`funds/${item?.amc_code}` + ".png")
                              : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                          }
                          sx={{
                            height: 35,
                            minwidth: 35,
                            m: 0.6,
                            mb: 0,
                            width:'10%'
                          }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            marginLeft: 0.5,
                            width:'80%'
                          }}
                        >
                          <H4
                            fontSize={12}
                            fontWeight={500}
                            color="#000000"
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              display: "flex",
                              fontSize: 15,
                              mt: 0.13,
                            }}
                          >
                            {InsertDots(item?.scheme_name, 50)}
                          </H4>

                          <Grid
                            alignItems="center"
                            sx={{
                              display: "flex",
                            }}
                          >
                            <H5
                              fontSize={12}
                              color="#747474"
                              fontWeight={"400"}
                            >
                              {item?.asset_category} | 3Y Returns:{"  "}
                            </H5>
                            <H5
                              sx={{ ml: 0.5 }}
                              fontSize={12}
                              color="#747474"
                              fontWeight={"400"}
                            >
                              {threeYearsReturn(item) == "NA"
                                ? threeYearsReturn(item)
                                : `${threeYearsReturn(item)}%`}
                            </H5>
                          </Grid>
                        </Box>
                        <Grid xs={2} sx={{  width:'10%' }}>
                          <Grid container alignItems="center" sx={{ mt: 2 ,ml:1}}>
                            <Box
                              component="img"
                              sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                height: 12,
                                minwidth: 60,
                                ml: 0.5,
                              }}
                              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/startIcon.svg"
                              alt="saas-dasboard-footer"
                            />
                            <H4 sx={ratingText}>
                              {item?.vr_rating === "Not Rated" ||
                              item?.vr_rating?.length <= 0
                                ? 0
                                : item?.vr_rating?.length}
                            </H4>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                ))}
          </>
        </Grid>
      )}
    </>
  );
};

export default MFCollections;
const root = {
  borderBottom: "0.7px solid #DCDCDC",
  padding: "10px",
  width: "100%",
  display: {
    xs: "flex",
    md: "none",
    sm: "none",
  },
  flexDirection: {
    xs: "column",
    md: "none",
    sm: "none",
  },
  paddingX: "0px",
};

const ratingText = {
  color: "#000",
  fontFamily: "'Poppins', sans-serif",
  alignSelf: "center",
};

const sxStylebutton = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: "80%",
  mb: 1,
  mt: 1,
};
const cancel = {
  background: "#FFF5D1",
  color: "#000",
  width: "80%",
  mb: 1,
  mt: 1,
};

const scrollableContainerStyle = {
  height: "200px",
  overflow: "auto",
};
